import { defineStore } from "pinia";

export const useProviderHomeStore = defineStore("ProviderHome", () => {
  const state = useState('homeProvidersState', () => ({
    providers: [] as any[],
    isLoading: false,
    error: null
  }));

  async function fetchProviders() {
    state.value.isLoading = true;
    try {
      const response = await useFetch("/api/casino-games/providers");

      if (response.data.value) {
        state.value.providers = response.data.value as any[];
      }

    } catch (error) {
      console.error("Error getting providers:", error);
      state.value.providers = [];
    } finally {
      state.value.isLoading = false;
    }
  }

  return {
    state,
    fetchProviders
  };
});
